<script setup lang="ts">
import type { TpgChangeEvent } from '@tpg/grammar-web';

export interface GrammarSwitchProps {
  label?: string;
  disabled?: boolean;
  readOnly?: boolean;
  selected?: boolean;
  labelPosition?: 'leading' | 'trailing';
  formAssociated?: boolean;
  name?: string;
}

const props = withDefaults(defineProps<GrammarSwitchProps>(), {
  label: '',
  disabled: false,
  readOnly: false,
  selected: false,
  labelPosition: 'leading',
  formAssociated: true,
  name: '',
});

const emit = defineEmits(['change']);

function onChange(event: TpgChangeEvent<boolean>) {
  emit('change', event.value);
}
</script>

<template>
  <tpg-switch v-bind="props" @tpg-change="onChange" />
</template>
